import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const UpdateInfluencer = (
  userId: string,
  data: {
    [key: string]: string | number | boolean | null
  },
) => {
  return apiInstance.put(ApiPathConfig.UPDATE_INFLUENCER(userId), data)
}

export default UpdateInfluencer
